import { create } from "zustand";

const initialCenters = [
  {
    id: 1,
    name: "Centro de Salud La Guardia Norte",
    services: [
      {
        id: 1,
        name: "Medicina General",
        maxPerSlot: 5,
        avgTime: 12,
        slots: ["08:00-09:00", "09:00-10:00", "10:00-11:00"]
      },
      {
        id: 2,
        name: "Pediatría",
        maxPerSlot: 4,
        avgTime: 15,
        slots: ["08:00-09:00", "09:00-10:00"]
      }
    ]
  },
  {
    id: 2,
    name: "Centro de Salud La Guardia Sur",
    services: [
      {
        id: 3,
        name: "Medicina General",
        maxPerSlot: 6,
        avgTime: 10,
        slots: ["08:00-09:00", "09:00-10:00"]
      },
      {
        id: 4,
        name: "Laboratorio",
        maxPerSlot: 6,
        avgTime: 8,
        slots: ["08:00-09:00", "09:00-10:00"]
      }
    ]
  }
];

export const useHealthStore = create((set, get) => ({
  centers: initialCenters,
  tickets: JSON.parse(localStorage.getItem("tickets")) || [],

  // ======================
  // CREAR FICHA
  // ======================
  createTicket: ({ centerId, serviceId, slot, name, ci }) => {
    const newTicket = {
      id: Date.now(),
      centerId,
      serviceId,
      slot,
      name,
      ci,
      createdAt: Date.now(),
      status: "pendiente",
      startedAt: null,
      finishedAt: null,
      cancelledAt: null
    };

    const updated = [...get().tickets, newTicket];

    localStorage.setItem("tickets", JSON.stringify(updated));
    set({ tickets: updated });
  },

  // ======================
  // CANCELAR (hasta 1 hora antes)
  // ======================
  cancelTicket: (ticketId) => {
    const updated = get().tickets.map(t => {
      if (t.id !== ticketId) return t;

      const now = Date.now();
      const slotHour = parseInt(t.slot.split(":")[0]);
      const today = new Date();
      today.setHours(slotHour, 0, 0, 0);

      const diff = today.getTime() - now;

    //   if (diff < 60 * 60 * 1000) {
    //     alert("Solo se puede cancelar hasta 1 hora antes del horario.");
    //     return t;
    //   }

      return { ...t, status: "cancelado", cancelledAt: now };
    });

    localStorage.setItem("tickets", JSON.stringify(updated));
    set({ tickets: updated });
  },

  // ======================
  // DISPONIBILIDAD
  // ======================
  getSlotAvailability: (centerId, serviceId, slot) => {
    const { tickets, centers } = get();
    const center = centers.find(c => c.id === centerId);
    const service = center.services.find(s => s.id === serviceId);

    const count = tickets.filter(
      t =>
        t.centerId === centerId &&
        t.serviceId === serviceId &&
        t.slot === slot &&
        t.status !== "cancelado"
    ).length;

    return {
      used: count,
      max: service.maxPerSlot,
      available: service.maxPerSlot - count
    };
  },

  // ======================
  // SIMULACIÓN MUNICIPAL
  // ======================
  startAttention: (ticketId) => {
    const updated = get().tickets.map(t =>
      t.id === ticketId
        ? { ...t, status: "en_atencion", startedAt: Date.now() }
        : t
    );
    localStorage.setItem("tickets", JSON.stringify(updated));
    set({ tickets: updated });
  },

  finishAttention: (ticketId) => {
    const updated = get().tickets.map(t =>
      t.id === ticketId
        ? { ...t, status: "finalizado", finishedAt: Date.now() }
        : t
    );
    localStorage.setItem("tickets", JSON.stringify(updated));
    set({ tickets: updated });
  }
}));